import { ApolloProvider } from '@apollo/client';
import React from 'react'

import PixelGenerator from '../components/PixelGenerator/PixelGenerator';
import useGraphQL from '../hooks/useGraphQL';

function PixelGeneratorPage() {
    const client = useGraphQL();
    return (
       <ApolloProvider client={client}>
            <PixelGenerator />
       </ApolloProvider>
    );
}

export default PixelGeneratorPage;